import { Check, TriangleAlert } from "lucide-react";

/**
 * The two notice cards `CoachGoals.dc.html` draws for a goal form: the
 * failure card (3px red left border, a warning icon, a 14px 600 ink title,
 * an optional 12px muted line) and the saved card (3px navy left border, a
 * tick). Shared by the New goal sheet and the opened goal's Update/Delete
 * (#1219, D283).
 */
const CARD = {
  display: "flex",
  gap: 10,
  padding: "12px 14px",
  background: "var(--nw-surface)",
  border: "1px solid var(--nw-line)",
  borderRadius: "var(--nw-radius-card)",
};

export function FailureCard({ title, body, "data-testid": testId }) {
  return (
    <div role="alert" data-testid={testId} style={{ ...CARD, borderLeftWidth: 3, borderLeftColor: "var(--nw-alert)" }}>
      <span style={{ display: "inline-flex", flexShrink: 0, paddingTop: 1 }}>
        <TriangleAlert size={16} color="var(--nw-alert)" strokeWidth={2} aria-hidden="true" />
      </span>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {title && <div style={{ fontSize: 14, lineHeight: 1.45, fontWeight: 600, color: "var(--nw-ink)" }}>{title}</div>}
        {body && <div style={{ fontSize: 12, lineHeight: 1.5, color: "var(--nw-ink-muted)" }}>{body}</div>}
      </div>
    </div>
  );
}

export function SavedCard({ children, "data-testid": testId }) {
  return (
    <div role="status" data-testid={testId} style={{ ...CARD, alignItems: "center", borderLeftWidth: 3, borderLeftColor: "var(--nw-navy)" }}>
      <Check size={16} color="var(--nw-navy)" strokeWidth={2.5} aria-hidden="true" style={{ flexShrink: 0 }} />
      <div style={{ fontSize: 14, lineHeight: 1.45, fontWeight: 600, color: "var(--nw-ink)" }}>{children}</div>
    </div>
  );
}
